import React from 'react';
import Link from '../atoms/Link';
import Text from '../atoms/Text';
import { commonRoutes } from '../../routes';
import { useTranslate } from '../../translate/I18n';
import { translateRoute } from '../../routesActions/routeHelper';

const {
  general: { copyrightCalculator }
} = commonRoutes;
const CopyrightCalculatorButton = props => {
  const { t, i18n } = useTranslate(['mission']);
  return (
    <Link
      styleType="transparentWithBorder"
      title={t('copyrightCalculator:ctaToolTip')}
      to={translateRoute(copyrightCalculator.to, 'en', i18n.language)}
      target="_blank"
      {...props}>
      <Text styleName="wPLightWeight">
        {t('mission:copyrightCalculatorLink')}
        <img width="12" height="12" src="/assets/icons/extra-link.png" alt="Copyright Calculator Link" />
      </Text>
    </Link>
  );
};

export default CopyrightCalculatorButton;
